import React from "react";
import "./index.scss";
import axios from "axios";
import { toast } from "react-toastify";
import { getStorageItem } from "../../utils/sessionStorage";

const index = ({
  type,
  id,
  details,
  isProductPresent,
  productId,
}) => {
  const userId = getStorageItem("user_id");
  const userName = getStorageItem("full_name");
  const userEmail = getStorageItem("user_email");
  const accessToken = getStorageItem("token");
  const handleNotifyMe = async () => {
    if(!productId) {
      console.log("No product id found");
      return;
    }
    const options = {
      method: "POST",
      url:
        global.config.ROOTURL.prod +
        "/marketplace/product/addUserToNotification",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
      data: {
        userId : userId ,
        userEmail: userEmail,
        userName: userName,
        productId: productId
      }
    };
    axios(options)
      .then((data) => {
        console.log(data);
        toast.success(
          "You will be notified on your registered email once this product gets back in stock."
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  if (!type) {
    return <div></div>;
  }
  if (type === "buy-now") {
    return <button className="btn-buy-cart">Buy Now</button>;
  } else if (type === "add-to-cart") {
    return (
      <button
        className={
          isProductPresent ? "product-present-in-cart" : "btn-buy-cart"
        }
      >
        Add to cart
      </button>
    );
  } else if (type === "notify-me") {
    return (
      <button className="btn-notify-me" onClick={handleNotifyMe}>
        Notify Me
      </button>
    );
  } else {
    return <div></div>;
  }
};

export default index;
